import { createFrameCanvas, FrameCanvas, releaseFrameCanvas } from 'modules/match-video/domain/assembler/frame-canvas';
import { ReviewCanvasContext } from 'modules/match-video/domain/interfaces';
import { loadTabularFont } from 'modules/match-video/domain/repositories/tabular-font-repository';
import { createGrain, Grain } from './grain';
import { loadSceneFonts } from './scene-fonts';
import { loadSceneImage } from './scene-image';

export interface SceneCanvas {
  canvas: FrameCanvas;
  ctx: ReviewCanvasContext;
  release(): void;
}

/** What a built-in scene needs from the browser while it is built; tests pass their own. */
export interface SceneEnv {
  loadFonts(fonts: readonly string[]): Promise<string[]>;
  /** A copy of a font with tabular figures; `null` — draw with the proportional face. */
  loadTabularFont(family: string, weight: number): Promise<string | null>;
  loadImage(url: string | undefined | null): Promise<HTMLImageElement | null>;
  createGrain(): Grain;
  /** An offscreen canvas: 1 × 1 to measure texts, or a layer drawn once and reused every frame. */
  createCanvas(width: number, height: number): SceneCanvas;
}

export const browserSceneEnv: SceneEnv = {
  loadFonts: (fonts) => loadSceneFonts(fonts),
  loadTabularFont: (family, weight) => loadTabularFont(family, weight),
  loadImage: (url) => loadSceneImage(url),
  createGrain: () => createGrain(),
  createCanvas: (width, height) => {
    const { canvas, ctx } = createFrameCanvas(width, height);
    return { canvas, ctx, release: () => releaseFrameCanvas(canvas) };
  },
};
